import Card from '@/components/common/Card';
import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import { useState } from 'react';

interface StatCardProps {
    title: string;
    value: number;
    color: string;
    showSubtitle: boolean;
    subtitleText?: string;
}

const SuperAdminDashboard: React.FC = () => {
    const [stats] = useState<StatCardProps[]>([
        {
            title: "Total Employees",
            value: 18,
            color: "rgb(15, 23, 42)",
            showSubtitle: false
        },
        {
            title: "Present Today",
            value: 14,
            color: "rgb(22, 163, 74)",
            showSubtitle: true,
            subtitleText: "of 18"
        },
        {
            title: "On Leave",
            value: 2,
            color: "rgb(14, 165, 233)",
            showSubtitle: false
        },
        {
            title: "Pending Approvals",
            value: 3,
            color: "rgb(217, 119, 6)",
            showSubtitle: false
        }
    ]);
    const [workforceAnalysis] = useState([
        {
            title: "Average Age",
            value: "34 yrs",
            color: "rgb(15, 23, 42)",
            subtitle: "across 18 staff"
        },
        {
            title: "Avg Experience",
            value: "6.2 yrs",
            color: "rgb(15, 23, 42)",
            subtitle: "across 18 staff"
        },
        {
            title: "Turnover Ratio",
            value: "0%",
            color: "rgb(22, 163, 74)",
            subtitle: "Dec 2025"
        },
        {
            title: "Gender Ratio",
            value: "F 55% · M 45%",
            color: "rgb(15, 23, 42)",
            subtitle: "10 F · 8 M"
        }
    ]);

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading title='Dashboard' />
                <div className="grid grid-cols-4 gap-4 mb-6">
                    {stats.map((stat, index) => (
                        <Card key={index} >
                            <div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                                {stat.title}
                            </div>
                            <div
                                className="mt-2 font-display text-2xl font-semibold"
                                style={{ color: stat.color }}
                            >
                                {stat.value}
                            </div>
                            {stat.showSubtitle && (
                                <div className="mt-1 text-xs text-slate-500">
                                    {stat.subtitleText}
                                </div>
                            )}
                        </Card>
                    ))}
                </div>
                <div className='grid grid-cols-2 gap-6'>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Department Headcount</h3>

                    </Card>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Credential Alerts</h3>
                    </Card>
                </div>
                <div className='grid grid-cols-2 gap-6'>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Recent Leave Requests</h3>

                    </Card>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Attendance Trend (last 7 days)</h3>
                    </Card>
                </div>
                <Card>
                    <h3 className="font-display mb-4 text-base font-semibold">Team Wellness Today</h3>
                </Card>
                <h2 className="font-display text-lg font-semibold text-slate-800 mb-4">Workforce Analytics</h2>

                <div className="grid grid-cols-4 gap-4 mb-4">
                    {workforceAnalysis.map((stat, index) => (
                        <Card
                            key={index}
                        >
                            <div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                                {stat.title}
                            </div>
                            <div
                                className="mt-2 font-display text-2xl font-semibold"
                                style={{ color: stat.color }}
                            >
                                {stat.value}
                            </div>
                            <div className="mt-1 text-xs text-slate-500">
                                {stat.subtitle}
                            </div>
                        </Card>
                    ))}
                </div>
                <div className='grid grid-cols-2 gap-6'>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Department-wise Gender Distribution</h3>

                    </Card>
                    <Card>
                        <h3 className="font-display mb-4 text-base font-semibold">Staff by Designation Level</h3>
                    </Card>
                </div>
            </div>
        </Layout>
    )
}

export default SuperAdminDashboard